import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';

export default class FinishGoodQualityInspectionFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardId = '';
		this.controlCardControlCardNumber = '';
		this.qtyBeforeFrom = '';
		this.qtyBeforeTo = '';
		this.qtyAfterFrom = '';
		this.qtyAfterTo = '';
		this.qtyPendingFrom = '';
		this.qtyPendingTo = '';
		this.qtyNgFrom = '';
		this.qtyNgTo = '';
		this.metodeQcId = '';
		this.metodeQcName = '';
		this.partId = '';
		this.partPartNumber = '';
		this.workOrderProcessDetailId = '';
		this.workOrderProcessDetailPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			controlCardId: '0',
			controlCardControlCardNumber: '0',
			qtyBeforeFrom: '0',
			qtyBeforeTo: '0',
			qtyAfterFrom: '0',
			qtyAfterTo: '0',
			qtyPendingFrom: '0',
			qtyPendingTo: '0',
			qtyNgFrom: '0',
			qtyNgTo: '0',
			metodeQcId: '0',
			metodeQcName: '0',
			partId: '0',
			partPartNumber: '0',
			workOrderProcessDetailId: '0',
			workOrderProcessDetailPart: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}